/**
 * Module prospection
 * @module app.prospection
 */
define([
    'angular',
    'moment',
    'bootstrap',
    'ui-bootstrap4',
    'angular-ui-notification',
    'angular-fr',
    'modules/prospection/common/index',
    'modules/prospection/search/index',
    'modules/prospection/store/index',
    'modules/prospection/wallet/index'
], function(angular) {


    angular.module('app.prospection', [
        'app.prospection.common',
        'app.prospection.search',
        'app.prospection.store',
        'app.prospection.wallet'
    ]);
});
